import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['form', 'keyField'];

  declare formTarget: HTMLFormElement;
  declare keyFieldTarget: HTMLInputElement;

  connect(): void {
    // Initialize component
  }

  // Handle blur events - submit when the user leaves the field
  public handleKeyBlur(event: FocusEvent): void {
    this.submitForm();
  }

  private submitForm(): void {
    if (this.hasFormTarget && this.keyFieldTarget.value.trim() !== '') {
      this.formTarget.requestSubmit();
    }
  }
}

